import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
export function ValueStack() {
  const items = ['Guía principal completa en PDF', 'Checklist de hábitos íntimos', 'Diario de síntomas', 'Lista de señales de alerta', 'Preguntas para consulta médica', 'Plan de bienestar íntimo de 7 días', 'Acceso inmediato y descarga instantánea'];
  const scrollToCTA = () => {
    const ctaSection = document.getElementById('main-cta');
    if (ctaSection) {
      ctaSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-16 md:py-24 px-4 bg-bg-secondary" data-id="element-310">
      <div className="max-w-4xl mx-auto" data-id="element-311">
        <motion.h2 className="font-heading text-3xl md:text-4xl font-bold text-heading mb-12 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-312">
          Todo lo que obtienes hoy
        </motion.h2>

        <motion.div className="overflow-x-auto rounded-2xl shadow-lg mb-10" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-313">
          <table className="w-full bg-white" data-id="element-314">
            <thead data-id="element-315">
              <tr className="bg-accent-lilac" data-id="element-316">
                <th className="px-6 py-4 text-left font-heading text-lg text-heading" data-id="element-317">
                  Elemento
                </th>
                <th className="px-6 py-4 text-center font-heading text-lg text-heading" data-id="element-318">
                  Incluido
                </th>
              </tr>
            </thead>
            <tbody data-id="element-319">
              {items.map((item, index) => <tr key={index} className="border-b border-gray-100" data-id="element-320">
                  <td className="px-6 py-4 text-body" data-id="element-321">{item}</td>
                  <td className="px-6 py-4 text-center" data-id="element-322">
                    <CheckCircleIcon className="w-6 h-6 text-green-600 mx-auto" data-id="element-323" />
                  </td>
                </tr>)}
            </tbody>
          </table>
        </motion.div>

        <motion.p className="text-center text-xl font-bold text-heading mb-8" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-324">
          Todo en un solo recurso. Sin suscripciones. Sin complicaciones.
        </motion.p>

        <motion.div className="flex justify-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} data-id="element-325">
          <button onClick={scrollToCTA} className="bg-button text-white px-10 py-5 rounded-full text-lg md:text-xl font-semibold hover:bg-[#A88BA8] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105" data-id="element-326">
            📥 Quiero mi guía ahora
          </button>
        </motion.div>
      </div>
    </section>;
}